module.exports = "/_next/static/images/icon-hiding-421b56c8.png";